import * as React from 'react';
const ClockIcon = ({ width = 20, height = 20, ...props }) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 15 15'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 7.5a7.5 7.5 0 1 1 15 0 7.5 7.5 0 0 1-15 0m7 0V3h1v4.293l2.854 2.853-.708.708-3-3A.5.5 0 0 1 7 7.5'
      fill='currentColor'
    />
  </svg>
);
export default ClockIcon;
